
import {updateField} from './RenderForm';

/* locates special handling items inside the form */



function findEntity(schema,key,property,custom)
	{
	var entry=null;
	schema.components.some((x)=>
		{
		if (!custom&&x[property]==key)
			{
			entry=x;
			return true;
			}
		else if (custom&&x.properties&&x.properties[property]==key)
			{
			entry=x;
			return true;
			}
		else if (x.components)
			{
			entry=findEntity(x,key,property,custom);
			if (entry)
				return true;
			}
		return false;
		})
	return entry;
	}
	
function validateTableEntry(dispatch,tableEntry, formData)
	{
	console.log("validateTableEntry",tableEntry, formData.current);
	const key=tableEntry.properties?.tableKey;
	const index=tableEntry.properties?.tableIndex;
	var baseArray;
	return tableEntry.columns.every((x)=>
		{
		var dataKey=tableEntry.properties[x.key];		//this gives the ability to rename things
		console.log(dataKey,x);
		if (dataKey===undefined)
			dataKey=x.key;
		console.log(x.key,dataKey,formData.current[dataKey]);
		if (Object.hasOwn(formData.current, "ZZ$required "+dataKey)&&formData.current["ZZ$required "+dataKey])
			{
			var value=formData.current[dataKey];
			console.log(value);
			if (value == null || String(value).trim() === "") 
				{
				console.log("Invalid form data");
				dispatch(updateField({field:"ZZformErrors",value:[dataKey]}));  
				
				return false;		//we skip over it as no file to check	
				}
			}
		return true;
		});		
	}

async function processTableEntry(dispatch,tableEntry,formData,fileEntry,entriesRemaining,uploadedRef=null,instanceID=null)
	{
	var ref=uploadedRef;

	if (fileEntry&&!ref)
		{
		ref=await handleUpload(fileEntry,instanceID);
		if (!ref)
			return;
		}//
	console.log("processTableEntry",tableEntry, formData.current, fileEntry, entriesRemaining);
	const key=tableEntry.properties?.tableKey;
	const index=tableEntry.properties?.tableIndex;

	var baseArray;
	if (!formData.current[key]||!formData.current[key].length)
		baseArray=[];
	else
		baseArray=[...formData.current[key]];

	var tableIndex=(index&&formData.current[index])?formData.current[index]:1;
	var newObj={ref:ref?ref:undefined,_name:fileEntry?.name};

	tableEntry.columns.forEach((x)=>
		{
		var dataKey=tableEntry.properties[x.key];		//this gives the ability to rename things
		console.log(dataKey,x);
		if (dataKey===undefined)
			dataKey=x.key;

		if (x.key!="_name")
			newObj[x.key]=formData.current[dataKey];

		if (x.key=="_id")
			{
			newObj[x.key]=tableIndex;
			tableIndex++;
			dispatch(updateField({field:index,value:tableIndex}));
			formData.current[index]=tableIndex;		//this doesn't have an autoupdate, so need to manually do it
			}
		if (!entriesRemaining&&x.key!="_id")
			{
			dispatch(updateField({field:dataKey,value:""}));
			formData.current[dataKey]="";
			}
		});		
	baseArray.push(newObj);
	console.log(key,baseArray);
	formData.current[key]=baseArray;
	console.log(baseArray);
	dispatch(updateField({field:key,value:baseArray}));
	return true;
	}
	
export async function processTable(dispatch,schema,formData,id,instanceID)
	{
	var tableEntry=findEntity(schema,id.tableKey,"tableKey",true);
	if (!tableEntry)
		{
		console.log("tableEntry not found",id,schema);
		return null;
		}

	if (tableEntry.properties?.tableType=="file")
		{
		if (!formData.current.ZZfiles)
			return;

		if (!validateTableEntry(dispatch,tableEntry,formData))
			return;

		var files=Array.from(formData.current.ZZfiles[tableEntry.properties.tableKey]||[]);

		var uploaded=await Promise.all(files.map(async file=>
			({
			file,
			ref:await handleUpload(file,instanceID)
			})));

		for (var i=0;i<uploaded.length;i++)
			{
			if (!uploaded[i].ref)
				continue;
			await processTableEntry(
				dispatch,
				tableEntry,
				formData,
				uploaded[i].file,
				i!=(uploaded.length-1),
				uploaded[i].ref,
				instanceID
				);
			}
		delete formData.current.ZZfiles[tableEntry.properties.tableKey];
		return true;
		}
	return processTableEntry(dispatch,tableEntry,formData,null,false,instanceID);
	}

async function handleUpload(file,instanceID) 
	{
	const formData = new FormData();
	formData.append("myFile", file); // "myFile" must match PHP's $_FILES key
	formData.append("action","fileUpload");
	formData.append("instance",instanceID);
	var token=localStorage.getItem('authToken');
	if (token)
		token=JSON.parse(token);
	try 
		{
		  const response = await fetch("https://docsasudo.com/processflow.php", {
			method: "POST",
			body: formData,
			
			credentials: "include", // 👈 ensures cookies/session are sent
			headers: {
				Authorization:`Bearer ${token.jwt}`
				// Don't manually set Content-Type, fetch will set correct multipart boundary
				}
		  });
		const result = await response.json();
		console.log("Success:", result.data);
		return result.data[0];
		} 
	catch (error) 
		{
		console.error("Error:", error);
		}
	};

